import React, { useEffect, useState } from 'react';
import {
  ProjectDetailsFilter,
  ProjectDetailsField,
  ProjectDetailsFieldType,
  useProjectDetailsFieldsAdminService,
} from 'nekst-api';
import { useSetupAreaVersionContextRequired } from '../SetupAreaVersionContext';
import { useFilterContext } from 'ui-builder';
import {
  Dropdown,
  FormTemplate,
  Header4,
  Row6x6x,
  SimpleBlock,
  useListContextRequired
} from 'ui-builder';
import styles from '../../../projectdetails/List/SetProjectDatesFieldsForm.module.scss';
import { useTeamSetupAreaContext } from '../../../markets/TeamSetupAreaContext';

interface ClosingDateFieldConfiguration {
  closingDateFieldId?: number;
}

interface CommissionFieldConfiguration {
  commissionFieldId?: number;
}

export default function SetCommissionFieldsForMarketForm() {
  const { setupArea, setupAreaVersion } = useSetupAreaVersionContextRequired();
  const filterContext = useFilterContext<ProjectDetailsFilter>();
  const setupAreaContext = useTeamSetupAreaContext();
  const fieldsService = useProjectDetailsFieldsAdminService();
  const listContext = useListContextRequired<ProjectDetailsField>();

  const projectType = filterContext.filterValue?.projectType;

  const [dateFields, setDateFields] = useState<ProjectDetailsField[]>();
  const [priceFields, setPriceFields] = useState<ProjectDetailsField[]>();

  useEffect(() => {
    if (listContext.data?.length && !listContext.isLoading) {
      setDateFields(
        listContext.data
          .filter((item) => !item.isHidden)
          .filter((item) => item.fieldType === ProjectDetailsFieldType.DATE)
      );
      setPriceFields(
        listContext.data
          .filter((item) => !item.isHidden)
          .filter((item) => item.fieldType === ProjectDetailsFieldType.PRICE)
      );
    }
  }, [listContext.version]);

  if (projectType && setupArea.market && (!setupAreaContext || !setupAreaContext.teamSetupArea.isCustom) && dateFields && priceFields) {
    const closingDateInitialData: ClosingDateFieldConfiguration = {
      closingDateFieldId: listContext.data.find((item) => item.isClosingDateField)?.id
    };

    const commissionInitialData: CommissionFieldConfiguration = {
      commissionFieldId: listContext.data.find((item) => item.isCommissionField)?.id
    };

    return (
      <SimpleBlock className={styles.block}>
        <Header4>For Commission Tracking:</Header4>
        <Row6x6x>
          <FormTemplate<ClosingDateFieldConfiguration>
            key={`closing-date-${projectType}-${listContext.version}`}
            initialData={closingDateInitialData}
            submitFormFunc={async (data) => {
              await fieldsService.setClosingDateField(
                setupArea.id,
                setupAreaVersion.version,
                projectType,
                data.closingDateFieldId
              );
              return data;
            }}
            buttons={null}
            dependencies={[projectType]}
            submitOnEachChange
          >
            <Dropdown
              source="closingDateFieldId"
              label="Closing Date"
              options={dateFields.map((item) => ({
                value: item.id,
                label: item.name
              }))}
            />
          </FormTemplate>
          <FormTemplate<CommissionFieldConfiguration>
            key={`commission-${projectType}-${listContext.version}`}
            initialData={commissionInitialData}
            submitFormFunc={async (data) => {
              await fieldsService.setCommissionField(
                setupArea.id,
                setupAreaVersion.version,
                projectType,
                data.commissionFieldId
              );
              return data;
            }}
            buttons={null}
            dependencies={[projectType]}
            submitOnEachChange
          >
            <Dropdown
              source="commissionFieldId"
              label="Commission"
              options={priceFields.map((item) => ({
                value: item.id,
                label: item.name
              }))}
            />
          </FormTemplate>
        </Row6x6x>
      </SimpleBlock>
    );
  } else {
    return null;
  }
}
